import React, { useEffect } from 'react';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import { useStore } from '../../../../stores/root';
import styles from './styles.module.scss';

// assets
import { faArrowRight, faXmarkCircle } from '@fortawesome/pro-light-svg-icons';

// services
import OrderService from '../../../../services/orders/order';

// props
import { IOrderResourceProps, IOrderResourceShortProps, IOrderResourcerShorterProps } from '../../../../props/orders/order';

// components
import { ActionButton, CommandBar, DatePicker, Dropdown, IButtonProps, ICommandBarItemProps, PrimaryButton, SpinnerSize, Stack } from '@fluentui/react';
import Text from '../../../typography/text';
import LoadingComponent from '../../../feedbacks/loading';
import Label from '../../../typography/label';
import Tag, { TTagVariant } from '../../../uiframeworks/tag';
import GeneralService from '../../../../services/general';
import ErrorService from '../../../../services/general/error';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OrdersDashboardChartFilter, { SelectedFilterProps } from './filters';
import OrdersDashboardTotalOrdersChart from './graphs/totalOrders';
import OrdersDashboardIncomesOutcomesChart from './graphs/incomesOutcomes';
import DetailsStack from '../../../uiframeworks/detailsStack';
import OrdersDashboardTotalProfitChart from './graphs/totalProfit';
import OrdersList from '../../general/list';
import OrdersDashboardTotalCustomersChart from './graphs/totalCustomers';

type OrdersPerformanceSummaryProps = {
    orders: IOrderResourceShortProps[];
}

type PerformanceSummaryData = {
    totalProfits: number;
    totalOrders: number;
    unpaidAmount: number;
}

const OrdersPerformanceSummary: React.FC<OrdersPerformanceSummaryProps> = (props: OrdersPerformanceSummaryProps) => {
    const [data, setData] = React.useState<PerformanceSummaryData>({totalProfits: 0, totalOrders: 0, unpaidAmount: 0});

    useEffect(() => {
        init(props.orders);
    }, [props.orders]);

    const init = (orders: IOrderResourceShortProps[]) => {
        let totalProfits: number = 0;
        let totalOrders: number = orders.length;
        let unpaidAmount: number = 0;

        orders.forEach((order) => {
            totalProfits += Number(Number(order.nettProfit).toFixed(2));
            unpaidAmount += Number(Number(order.unpaidAmount).toFixed(2));
        });

        setData({totalProfits, totalOrders, unpaidAmount})


    }

    return <Stack horizontal className={styles.container} tokens={{childrenGap: 20}}>
        <Stack tokens={{childrenGap: 5}} className={styles.card} styles={{root: {width: '33.3%'}}}>
            <Text size={"small"}>Total profit</Text>
            <Label className={'color-green'} size={'xlarge'}>Rp. {GeneralService.getNumberWithSeparator(data.totalProfits)}</Label>
        </Stack>
        <Stack tokens={{childrenGap: 5}} className={styles.card} styles={{root: {width: '33.3%'}}}>
            <Text size={"small"}>Total orders</Text>
            <Label className={'color-blue'} size={'xlarge'}>{GeneralService.getNumberWithSeparator(data.totalOrders)}</Label>
        </Stack>
        <Stack tokens={{childrenGap: 5}} className={styles.card} styles={{root: {width: '33.3%'}}}>
            <Text size={"small"}>Unpaid amount</Text>
            <Label className={'color-red'} size={'xlarge'}>Rp. {GeneralService.getNumberWithSeparator(data.unpaidAmount)}</Label>
        </Stack>
    </Stack>;
};

export default OrdersPerformanceSummary;
